module.exports = __webpack_public_path__ + "img/sponsorE32.64670276.png";